/** Method key for the `@connected` hook that hides the host element (see `headless.ts`). */
export const hideable = Symbol('hideable')
